// Centralized Firebase configuration
// Active Project: okreedba (Migrated for examination)
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBSKP0duvcKYeBG8wfjHb_zDWUG7q1WKs4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "okreedba.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "okreedba",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "okreedba.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "187685782105",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:187685782105:web:415a3584daad08eb66e748",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-SG8EEK2JL4"
};
